module.exports = __webpack_public_path__ + "img/Member icon-16.ac99e1ca.png";